var regSubmitUrl = '/customer/quickregister';
var loginSubmitUrl = '/customer/quicklogin';

jQuery(document).ready(function () {
    jQuery('.reg-holder').iziModal();

    jQuery("#agreePrivacy").change(function () {
        var valElem = jQuery("#agreePrivacyValidationError")
        if (jQuery(this).is(':checked')) {
            valElem.hide();
        }
        else {
            valElem.show();
        }
    });

    jQuery("#agreeTerms").change(function () {
        var valElem = jQuery("#agreeTermsValidationError");
        if (jQuery(this).is(':checked')) {
            valElem.hide();
        }
        else {
            valElem.show();
        }

    });
});

var dataPost = {};

var errorStrings = {
    fb_invalid_mail: "According to Facebook, this e-mail address is incorrect.",
    please_wait: "Your account is being created at this very moment.",
    unknown_error: "There are been some kind of error. Please try again later.",
    try_again_later: "We couldn't create the account at this moment. Please try again later",
    all_good: "Your account is being created at this very moment.",
    user_exists: "There is already a user with this e-mail address. <a href='/passwordrecovery'>Click here</a> if you forgot your password.",
    error_occured: "An error has occured",
    invalid_mail: 'Email is not valid',
    password_required: 'Password is required.',
    short_pass: "The password needs to be at least 6 symbols.",
    firstName_required: 'First name is required.',
    short_firstName: 'First name needs to be at least 2 symbols.',
    lastName_required: 'Last name is required.',
    short_lastName: 'Last name needs to be at least 2 symbols.'
};



//start modal in test mode
//isLoggedIn();

//to validate a email
function validateEmail(Email) {
    var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return jQuery.trim(Email).match(pattern) ? true : false;
}

//toggle and animations for modal
jQuery('.toggle').click(function (e) {

    e.preventDefault();
    jQuery('.validationerr').hide();
    jQuery('.toggle-content').slideToggle(0);

    jQuery('.arrow-down').toggleClass('active');

});

jQuery('input[type=checkbox]').change(function () {
    this.value = jQuery(this).is(':checked') ? true : false;
});

//login form submit on enter key
jQuery('.q-login-form input').keypress(function (e) {
    if (e.which == 13) {
        onSubmit('login-nav');
        return false;
    }
});

//registration form submit on enter key
jQuery('.registration-form input').keypress(function (e) {
    if (e.which == 13) {
        onSubmit('register-nav');
        return false;
    }
});

window.bindQuickRegModal = function (e) {
    if (jQuery(this).data('iscurrentuserloggedin') !== "True") {

        jQuery('.reg-holder').iziModal('open');

        e.preventDefault();
        e.stopPropagation();
        return false;
    }

};

//on submit function
window.onSubmit = function (form) {

    if (!validateInputs(form))
        return;

   // jQuery('.q-login-loading').show();
    jQuery("#" + form).hide();

    var submitUrl;
    if (form == 'login-nav') {
        submitUrl = loginSubmitUrl;
    }
    else {
        submitUrl = regSubmitUrl;
    }

    //var senderAmount = jQuery('#senderAmount').val();
    //var senderAmountWithoutRound = jQuery('#senderAmountWithoutRound').val();

    //if (senderAmountWithoutRound)
    //        dataPost["senderAmount"] = senderAmountWithoutRound;
    //else dataPost["senderAmount"] = senderAmount;

    jQuery(".form-error", "#" + form).hide();

    jQuery(".q-login-loader").show();

    var domain = window.location.origin;
    var path = window.location.pathname;
    var search = window.location.search;
    var returnUrl =  domain + path + search;
    
    dataPost.returnUrl = returnUrl;
        
    jQuery.ajax({
        url: submitUrl,
        method: "POST",
        data: dataPost,
        dataType: "json",
        success: function (data) {

            if (data.success) {
                if (data.redirect) {
                    window.location.href = domain + "/" + data.redirect;
                    return;
                }

                jQuery('form[data-quickreg="True"]').data('iscurrentuserloggedin', 'True');
                
                window.location.href = returnUrl;
            }
            else {
                jQuery(".form-error", "#" + form).text(data.errors).show();

                jQuery('.q-login-loading').hide();
                jQuery("#" + form).show();
            }
        },
        error: function (jqXHR, textStatus) {
            msg = '';
            error = jqXHR.responseJSON ? jqXHR.responseJSON.error : '';

            if (Array.isArray(error))
                msg = error[0];

            if (error === "userExists")
                msg = errorStrings.user_exists;

            if (msg != '')
                jQuery('.resultError').html(msg).show();

            jQuery('.q-login-loading').hide();
            jQuery("#" + form).show();
        },
        complete: function () {
            jQuery(".q-login-loader").hide();
        }
    });

}

function login($type) {
    var redirect = jQuery("#bt-loginfb").attr("data-redirect");
    window.location.href = redirect;
}

//validate all inputs
function validateInputs(form) {
    //hide all messages
    jQuery('.validationerr').hide();

    var allValid = true;

    jQuery("form#" + form + " :input").each(function () {
        input = jQuery(this); // This is the jquery object of the input, do what you will
        inputName = input.attr('name');
        inputValue = input.val();

        if (inputName != undefined) {
            // check if the input is not empty
            if (inputValue == "") {
                allValid = false;
                input.parent().find('.validationerr').show();
            } else {
                //check if is an email input
                if (inputName == 'mail') {
                    //and validate it
                    if (!validateEmail(inputValue)) {
                        allValid = false;
                        input.parent().find('.validationerr').show();
                    }
                } else if (inputName == 'agreeTerms') {
                    if (inputValue !== "true") {
                        allValid = false;
                        input.parent().find('.validationerr').show();
                    }
                } else if (inputName == 'agreePrivacy') {
                    if (inputValue !== "true") {
                        allValid = false;
                        input.parent().find('.validationerr').show();
                    }
                }

                dataPost[inputName] = inputValue;
            }
        }
    });

    //login or register - form
    if (form == "login-nav") {
        type = 'login';
    } else {
        type = 'register';
    }

    dataPost.type = type;

    return allValid;
}